import { _ as i } from "./index817.mjs";
import { _ as e } from "./index831.mjs";
import { _ as r } from "./index909.mjs";
var h = i, o = e, c = r, n = 200;
function f(_, s) {
  var t = this.__data__;
  if (t instanceof h) {
    var a = t.__data__;
    if (!o || a.length < n - 1)
      return a.push([_, s]), this.size = ++t.size, this;
    t = this.__data__ = new c(a);
  }
  return t.set(_, s), this.size = t.size, this;
}
var v = f;
export {
  v as _
};
